import classNames from "classnames"
import React from "react"

import Link from "@components/elements/Link"
import { handleOnClick } from "@utils/buttonEventHandler"

type Props = {
  link: string | YocoCom.YocoLink
  ariaLabel: string
  queryParams?: string
  trackingEvent?: string
  trackingEventKey?: string
  trackingEventValue?: string
  className?: string
}

const ClickableCardLink = ({
  link,
  ariaLabel,
  queryParams,
  trackingEvent,
  trackingEventKey,
  trackingEventValue,
  className,
}: Props) => {
  const linkUrl = typeof link === "string" ? link : link?.url

  return (
    <Link
      link={link}
      queryParams={queryParams}
      onClick={(e) =>
        handleOnClick({
          e,
          linkUrl,
          trackingEvent,
          trackingEventKey,
          trackingEventValue,
        })
      }
      aria-label={ariaLabel}
      className={classNames("absolute inset-0 z-10", className)}
    >
      <span />
    </Link>
  )
}

export default ClickableCardLink
